/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品分类</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入分类名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      </el-table-column>
            <el-table-column  prop="addTime" label="分类图片" width="100" >
        <template slot-scope="scope">
              <el-image
                style="width: 80px; height: 80px;border-radius: 10px;"
                src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
                :fit="fit"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable prop="deptNo" label="分类名称" width="150">
      </el-table-column>
            <el-table-column sortable prop="deptNo" label="商品分类" width="150">
      </el-table-column>

      <el-table-column sortable prop="editTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column>


      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="分类图片" prop="deptName">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="$adminImageUrl(imageUrl)" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="分类名字" prop="deptNo">
          <el-input size="small" v-model="editForm.deptNo" auto-complete="off" placeholder="分类名字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete, getClassifyList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取分类列表
    getdata(parameter) {
      this.loading = true
      getClassifyList({ token: localStorage.getItem('logintoken') })
        .then(res => {
          this.loading = false
          if (res.code == 200) {
            // 合并一级和二级分类用于显示
            const classifyList = res.data.classifyList || []
            const classifyTwoList = res.data.classifyTwoList || []

            // 将二级分类展开显示，带上父级名称
            this.listData = classifyTwoList.map(item => {
              const parent = classifyList.find(p => p.id === item.parentId)
              return {
                deptId: item.id,
                deptNo: item.name,
                deptName: parent ? parent.name : '',
                picture: item.picture,
                editTime: item.createTime || Date.now()
              }
            })

            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = this.listData.length
          } else {
            this.$message({
              type: 'info',
              message: res.msg || '获取分类列表失败'
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('网络错误')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$message.warning('分类管理的增删改功能需要后端先开发对应接口')
      // this.$refs[editData].validate(valid => {
      //   if (valid) {
      //     deptSave(this.editForm)
      //       .then(res => {
      //         this.editFormVisible = false
      //         this.loading = false
      //         if (res.success) {
      //           this.getdata(this.formInline)
      //           this.$message({
      //             type: 'success',
      //             message: '公司保存成功！'
      //           })
      //         } else {
      //           this.$message({
      //             type: 'info',
      //             message: res.msg
      //           })
      //         }
      //       })
      //       .catch(err => {
      //         this.editFormVisible = false
      //         this.loading = false
      //         this.$message.error('公司保存失败，请稍后再试！')
      //       })
      //   } else {
      //     return false
      //   }
      // })
    },
    // 删除分类
    deleteUser(index, row) {
      this.$message.warning('分类管理的增删改功能需要后端先开发对应接口')
      // this.$confirm('确定要删除吗?', '信息', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     deptDelete(row.deptId)
      //       .then(res => {
      //         if (res.success) {
      //           this.$message({
      //             type: 'success',
      //             message: '公司已删除!'
      //           })
      //           this.getdata(this.formInline)
      //         } else {
      //           this.$message({
      //             type: 'info',
      //             message: res.msg
      //           })
      //         }
      //       })
      //       .catch(err => {
      //         this.loading = false
      //         this.$message.error('公司删除失败，请稍后再试！')
      //       })
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消删除'
      //     })
      //   })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}



  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>

 
 



// WEBPACK FOOTER //
// src/views/goods/Classify.vue